import React from 'react';
import type { MetricItem, TestimonialItem } from '../types';

type Props = {
  metrics: MetricItem[];
  testimonials: TestimonialItem[];
};

export default function Results({ metrics, testimonials }: Props) {
  return (
    <section id="results" className="bg-white text-slate-950">
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-28">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm uppercase tracking-[0.22em] text-sky-600">Results</p>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-slate-950 md:text-5xl">
            When trust is part of the system, things behave differently
          </h2>
          <p className="mt-4 text-lg leading-8 text-slate-600">
            People act more easily. Brands show up more honestly. Decisions become clearer. Growth
            becomes less about forcing attention, and more about allowing it.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-4">
          {metrics.map((metric) => (
            <div
              key={metric.label}
              className="rounded-[28px] border border-slate-200 bg-slate-50 p-8 text-center shadow-sm"
            >
              <div className="text-4xl font-semibold tracking-tight text-sky-600">
                {metric.value}
              </div>
              <div className="mt-3 text-sm uppercase tracking-[0.18em] text-slate-500">
                {metric.label}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {testimonials.map((item) => (
            <div
              key={item.name}
              className="rounded-[30px] border border-slate-200 bg-white p-8 shadow-sm"
            >
              <div className="text-sm font-medium uppercase tracking-[0.18em] text-sky-600">
                {item.metric}
              </div>
              <p className="mt-4 text-lg leading-8 text-slate-800">“{item.quote}”</p>
              <div className="mt-6 border-t border-slate-200 pt-5">
                <div className="font-medium text-slate-950">{item.name}</div>
                <div className="text-sm text-slate-500">{item.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
